import { onBeforeUnmount, ref, watch } from 'vue';

/** 全局秒级时钟 — SLA 倒计时 / 入池等待时长 / 会话超时共用一个计时器，避免每行各起一个 */
const now = ref(Date.now());
let timer: number | null = null;
let subscribers = 0;

function ensureTimer(): void {
  if (timer !== null) return;
  timer = window.setInterval(() => {
    now.value = Date.now();
  }, 1000);
}

function releaseTimer(): void {
  if (subscribers > 0 || timer === null) return;
  window.clearInterval(timer);
  timer = null;
}

export function useNow() {
  subscribers += 1;
  ensureTimer();

  onBeforeUnmount(() => {
    subscribers = Math.max(0, subscribers - 1);
    releaseTimer();
  });

  return now;
}

/** 会话 30min 超时：剩余秒数归零时触发强制登出 */
export function useSessionCountdown(expiresAtMs: number, onExpire: () => void) {
  const clock = useNow();
  const remainingSeconds = ref(Math.max(0, Math.floor((expiresAtMs - Date.now()) / 1000)));
  let fired = false;

  const stop = watch(
    clock,
    (value) => {
      const left = Math.max(0, Math.floor((expiresAtMs - value) / 1000));
      remainingSeconds.value = left;
      if (left === 0 && !fired) {
        fired = true;
        onExpire();
      }
    },
    { immediate: true },
  );

  onBeforeUnmount(stop);

  return { remainingSeconds };
}
